import { useChartDisplay } from '../../../../ui-components/data-viz-ui/charts/common/common-chart-utils/use-chart-display-reducer';
import { ComponentStateManager } from '../../../common/types';
import { OverTimeSegmentedVizExternalProps } from '../../types';
import {
  OverTimeSegmentedLineChartActions,
  OverTimeSegmentedLineChartState,
} from './types';

export const useOverTimeSegmentedLineChartStateManager = (
  // We might need more props later, but I am not sure
  externalProps: OverTimeSegmentedVizExternalProps,
  persistenceKey: string
): ComponentStateManager<
  OverTimeSegmentedLineChartState,
  OverTimeSegmentedLineChartActions
> => {
  const { displayState, displayActions } = useChartDisplay(
    {
      enablePercentage: false,
      enableStack: false,
      enableLabels: true,
      enableLegend: true,
      enableSortOrder: true,
      enableTableView: true,
      globalDisplayState: externalProps.displayGlobalState,
    },
    persistenceKey
  );

  return {
    state: {
      displayState,
    },
    actions: {
      displayActions,
    },
  };
};
